function originalEventOf(event: Event): Event | undefined {
  if (!(event instanceof CustomEvent) || typeof event.detail !== 'object' || event.detail === null) {
    return undefined
  }
  const original: unknown = 'originalEvent' in event.detail ? event.detail.originalEvent : undefined
  return original instanceof Event ? original : undefined
}

/**
 * Whether a Sheet `interact-outside` event is a deliberate dismiss: a pointer on the sheet's
 * own backdrop. Focus moving out of the sheet, pointers on anything else outside it (toasts,
 * popovers, nested dialogs) and on the backdrop of a sheet stacked on top of it are not.
 */
export function isSheetDismissIntent(event: Event, overlay: Element | null | undefined): boolean {
  const original = originalEventOf(event)
  if (!overlay || !original || original.type === 'focusin') {
    return false
  }
  return original.target instanceof Node && overlay.contains(original.target)
}
